import { useContext } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import { PageSidePanelContainer } from '../../../../../../context'
import { isListViewTypeWithPreview } from '../../../../../../utils/listViewType'
import {
  MultipleViewTypeListActiveItemPreview,
  PREVIEW_MIN_WIDTH,
} from '../../../../../MultipleViewTypeList'
import { RequestProfileTabEmailsThreadPreview } from '../../../RequestProfileTabEmailsThreadPreview'
import { useRequestProfileTabEmailsThreadPreviewNavigation } from '../useRequestProfileTabEmailsThreadPreviewNavigation'

import { getActiveItemData } from './useRequestProfileTabEmailsThreadPreviewPanel.utils'

import EmailIcon from '../../../../../../icons/email.svg'

export function useRequestProfileTabEmailsThreadPreviewPanel({
  activeItem,
  className,
  items,
  listViewType,
  pagination,
  preview,
  profileLoadersRef,
  requestId,
  setActiveItem,
  onClosePreview,
  onGuardPreviewAction,
  onPreviewResizeEnd,
  onReloadList,
  onSetPagination,
  onSuccessRead,
}) {
  const { t } = useTranslation()

  const sidePanelContainer = useContext(PageSidePanelContainer)

  const {
    currentIndex,
    handleNext,
    handlePrevious,
    hasNext,
    hasPrevious,
    totalCount,
  } = useRequestProfileTabEmailsThreadPreviewNavigation({
    activeItem,
    items,
    pagination,
    setActiveItem,
    onGuardPreviewAction,
    onSetPagination,
  })

  function handleReleaseActiveItem() {
    setActiveItem(null)
  }

  const activeItemData = getActiveItemData(items, activeItem)

  const previewPanel = isListViewTypeWithPreview(listViewType) ? (
    <MultipleViewTypeListActiveItemPreview
      canResize
      Component={RequestProfileTabEmailsThreadPreview}
      activeItem={activeItem}
      className={className}
      componentProps={{
        audience: activeItemData?.audience,
        currentIndex,
        directoryId: activeItemData?.directory_id,
        hasNext,
        hasPrevious,
        profileLoadersRef,
        requestId,
        totalCount,
        onClosePreview,
        onNext: handleNext,
        onPrevious: handlePrevious,
        onReleaseActiveItem: handleReleaseActiveItem,
        onReloadList,
        onSuccessRead,
      }}
      emptyProps={{
        EntityIcon: EmailIcon,
        text: t('Emails.PreviewNoConversationsSelectedKey'),
        onClosePreview,
      }}
      resizeConfig={{
        initialWidth: preview?.size ?? PREVIEW_MIN_WIDTH,
        onResizeEnd: onPreviewResizeEnd,
      }}
    />
  ) : null

  return {
    previewPanel:
      sidePanelContainer && previewPanel
        ? createPortal(previewPanel, sidePanelContainer)
        : null,
  }
}
